import { PermissionAttributesEnum } from "./permissions.enum";

/**
 * Permission keys that only an exact grant gives: no wildcard (`global.*`, `global.app.*`, "all permissions") covers
 * them, so a role or bracket holds one only when the key itself is in it.
 *
 * Mirrors `App\Security\Permission\ExplicitPermissionKeys` on the API.
 */
export const EXPLICIT_PERMISSION_KEYS: readonly string[] = [
  PermissionAttributesEnum.GlobalAppInternalRead,
];

export function isExplicitPermissionKey(key: string): boolean {
  return EXPLICIT_PERMISSION_KEYS.includes(key);
}
